import { QueryParams } from '../../../utils/encodeQueryString';
import { getSearchAPIEndpoint } from '../../../utils/getSearchAPIEndpoint';
import { ApiResponse, PostForm } from '../apiUtils';

import {
  WidgetApiResponse,
  widgetApiResponseToWidgetResponse,
  WidgetResponse,
} from './createWidgetResponseGetter';

export const createWidgetResponsePost = (postForm: PostForm<WidgetApiResponse>) => {
  return async (formData: FormData, params?: QueryParams): Promise<ApiResponse<WidgetResponse>> => {
    return widgetApiResponseToWidgetResponse(
      await postForm(`${getSearchAPIEndpoint()}/widget.php`, formData, params),
    );
  };
};

export type WidgetResponsePost = ReturnType<typeof createWidgetResponsePost>;
